import { Dispatch, FC, SetStateAction } from 'react';
import { DiagnosticStateEnum } from './Diagnostic';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { ArrowRight } from 'lucide-react';
import resumeDgIcon from '../../assets/resume-dg-icon.svg';
import { DiagnosticSteps } from '../../models/DiagnosticStepsEnum';
import { requestFullscreen } from '../../utils/fullscreen';
import { usePreviewMode } from '../../contexts/PreviewModeContext';

interface Props {
  diagnosticState: DiagnosticStateEnum.RESUME | DiagnosticStateEnum.SAVEANDQUIT | null;
  setStepDiagnostic: Dispatch<SetStateAction<DiagnosticSteps>>;
  setDiagnosticState: Dispatch<SetStateAction<DiagnosticStateEnum | null>>;
  refechSessionInfo: () => void;
}

export const ResumeDiagnosticCard: FC<Props> = ({
  setDiagnosticState,
  setStepDiagnostic,
  refechSessionInfo,
  diagnosticState,
}) => {
  const previewMode = usePreviewMode();
  return (
    <Card className={`tw-w-[40rem] tw-h-[25rem] !tw-px-0 tw-mt-[5vh] !tw-pb-0`}>
      <div className="tw-bg-white !tw-h-[23rem] tw-w-full tw-h-full tw-rounded-b-2xl">
        <div className="tw-px-3 tw-h-[16.5rem] tw-mb-5">
          <img src={resumeDgIcon} className="tw-h-[5rem] tw-w-[5rem] tw-mx-auto tw-block" />
          <div className="tw-text-center tw-mt-6">
            <h1>{diagnosticState === DiagnosticStateEnum.RESUME ? `Welcome back!` : `Your progress is saved!`}</h1>
            <p
              className="tw-w-[50%] tw-mx-auto"
              style={{ fontFamily: 'Atkinson Hyperlegible', lineHeight: '1.7rem', fontSize: '1.2rem' }}
            >
              {diagnosticState === DiagnosticStateEnum.SAVEANDQUIT
                ? `Come back anytime to pick up where you left off.`
                : `Pick up where you left off.`}
            </p>
          </div>
        </div>

        <div className="tw-flex tw-justify-center tw-w-full">
          <Button
            onClick={() => {
              // Guided tour walks this same screen without a real diagnostic session.
              if (!previewMode) {
                requestFullscreen();
              }
              refechSessionInfo();
              setDiagnosticState(DiagnosticStateEnum.NEW);
              setStepDiagnostic(DiagnosticSteps.ASSESSMENT);
            }}
          >
            <div className="tw-flex tw-px-3 tw-justify-center">
              <span>Continue diagnostic</span>
              <ArrowRight size={20} className="tw-ml-2" />
            </div>
          </Button>
        </div>
      </div>
    </Card>
  );
};
